import { render, staticRenderFns } from "./notification-ValidationCommentMention.vue?vue&type=template&id=7dade4f9&scoped=true"
import script from "./notification-ValidationCommentMention.vue?vue&type=script&lang=js"
export * from "./notification-ValidationCommentMention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dade4f9",
  null
  
)

export default component.exports